import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { MailMessage_Interface } from 'src/app/Interface/MailMessage_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MailMessageService {
  constructor(private http:HttpClient) { }


  GetRecord(LetterType:number):Observable<Array<MailMessage_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Mailmessage?LetterType="+LetterType).pipe(
      map(data=>{
        return data as Array<MailMessage_Interface>
      })
    )
  }



  GetSingle(id:Number):Observable<General_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Mailmessage/GetSingle?id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )
  }

  AddMail_Message(model: General_Interface,letterType:number):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.code,
      username:'',
      letterType:letterType,
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Mailmessage/Add",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  EditMail_Message(model: General_Interface):Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      title:model.title,
      dsc:model.code,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Mailmessage/Edit",body,{headers}).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  DeleteMail_Message(id:number):Observable<General_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Mailmessage/Delete?id="+id).pipe(
        map(data=>{
          return data as General_Interface
        })
      )

  }

  PishPardakht(id:number):Observable<General_Interface>{

    return this.http.get(environment.BaseUrl + "Daro/Mailmessage/PishPardakht?id="+id).pipe(
      map(data=>{
        return data as General_Interface
      })
    )

}

  }
